function initialState() {
    return {
        item: {
            phone: null,
            company: null,
            message: null,
            accept: 0,
        },
        loading: false,
        gRecaptchaResponse: null
    }
}

const getters = {
    item:          state => state.item,
    loading:       state => state.loading
}

const actions = {
    send({ commit, state, rootState }) {
        commit('setLoading', true)
        return new Promise((resolve, reject) => {
            let params = new FormData();
            params.set('_method', 'POST')

            for (let fieldName in state.item) {
                let fieldValue = state.item[fieldName];
                if (typeof fieldValue !== 'object') {
                    params.set(fieldName, fieldValue);
                } else {
                    if (fieldValue && typeof fieldValue[0] !== 'object') {
                        params.set(fieldName, fieldValue);
                    } else {
                        for (let index in fieldValue) {
                            params.set(fieldName + '[' + index + ']', fieldValue[index]);
                        }
                    }
                }
            }

            params.set('gRecaptchaResponse', state.gRecaptchaResponse);
            params.set('language', rootState.Language.currentLanguage);

            axios.post('api/order-a-call-form', params)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    console.log(error)
                    reject(error)
                })
                .finally(() => {
                    commit('setLoading', false)
                })
        })
    },
    setPhone({ commit }, data) {
        commit('setPhone', data);
    },
    setCompany({ commit }, data) {
        commit('setCompany', data);
    },
    setMessage({ commit }, data) {
        commit('setMessage', data);
    },
    setAccept({ commit }, data) {
        commit('setAccept', data);
    },
    setgRecaptchaResponse({ commit }, data) {
        commit('setgRecaptchaResponse', data);
    },
    resetState({ commit }) {
        commit('resetState')
    }
}

const mutations = {
    setPhone(state, data) {
        state.item.phone = data;
    },
    setCompany(state, data) {
        state.item.company = data;
    },
    setMessage(state, data) {
        state.item.message = data;
    },
    setAccept(state, data) {
        state.item.accept = data;
    },
    setLoading(state, loading) {
        state.loading = loading
    },
    setgRecaptchaResponse(state, data) {
        state.gRecaptchaResponse = data;
    },
    resetState(state) {
        state = Object.assign(state, initialState())
    }
}

export default {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations
}
